/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit Display/view.blocks to change it.
import * as fromData from 'Simple/Data'
import * as fromDesignTokens from 'Simple/DesignTokens'
import Author from './Author/index'
import Content from './Content/index'
import Copy from 'DesignSystem/Copy/index'
import Delete from './Delete/index'
import DeleteAction from './DeleteAction/index'
import EditAction from './EditAction/index'
import Indicator from './Indicator/index'
import Info from './Info/index'
import React from 'react'
import styles from './view.module.css'



/** @type {import('Simple/types.js').View} */
export default function Display({
  children,
  viewPath = "/DesignSystem/TimelineEvent/Note/Content/Display"
  
}) {
let dtSpaceXs = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.xs'
        })
let dtSpaceS = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.s'
        })
let dtColorsOrange100 = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'colors.orange.100'
        })
let dtColorsOrange300 = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'colors.orange.300'
        })
let noteNoteValueData = fromData.useDataValue({ viewPath,
context: 'note',
path: 'note',
})
let dtColorsNeutral400 = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'colors.neutral.400'
        })
  return (<React.Fragment
>
<div
  data-testid="Display.Horizontal"
  data-view-path={viewPath}
 style={{'--mt-1-Z18e2r2': typeof dtSpaceXs === 'number' ? `${dtSpaceXs}px` : dtSpaceXs}}
 className={`views-block ${styles.Horizontal}`}
>
<Indicator
  viewPath={`${viewPath}/Indicator`}
/>
<div
  data-testid="Display.Horizontal:1"
  data-view-path={viewPath}
 style={{'--ml-2-Z18e2r2': typeof dtSpaceS === 'number' ? `${dtSpaceS}px` : dtSpaceS,'--mr-3-Z18e2r2': typeof dtSpaceS === 'number' ? `${dtSpaceS}px` : dtSpaceS,'--bc-4-Z18e2r2': dtColorsOrange100,'--bc-5-Z18e2r2': dtColorsOrange300,'--bblr-6-Z18e2r2': typeof dtSpaceXs === 'number' ? `${dtSpaceXs}px` : dtSpaceXs,'--bbrr-7-Z18e2r2': typeof dtSpaceXs === 'number' ? `${dtSpaceXs}px` : dtSpaceXs,'--btlr-8-Z18e2r2': typeof dtSpaceXs === 'number' ? `${dtSpaceXs}px` : dtSpaceXs,'--btrr-9-Z18e2r2': typeof dtSpaceXs === 'number' ? `${dtSpaceXs}px` : dtSpaceXs}}
 className={`views-block ${styles.Horizontal1}`}
>
<Content
  viewPath={`${viewPath}/Content`}
/>
<div
  data-testid="Display.Horizontal:2"
  data-view-path={viewPath}
 style={{'--mr-3-Z18e2r2': typeof dtSpaceXs === 'number' ? `${dtSpaceXs}px` : dtSpaceXs}}
 className={`views-block ${styles.Horizontal2}`}
>
<Author
  viewPath={`${viewPath}/Author`}
/>
<EditAction
  viewPath={`${viewPath}/EditAction`}
/>
<DeleteAction
  viewPath={`${viewPath}/DeleteAction`}
/>
<Copy
  viewPath={`${viewPath}/Copy`}
 fill={dtColorsNeutral400}
 marginLeft={0}
 data="note.note"
 value={noteNoteValueData}
 text="Copy Note"
/>
<Info
  viewPath={`${viewPath}/Info`}
/>
</div>
</div>
<Delete
  viewPath={`${viewPath}/Delete`}
/>
</div>
{children}
</React.Fragment>)
}